module.exports = __webpack_public_path__ + "img/Vision.97327f64.jpeg";